module.exports = __webpack_public_path__ + "Flag-144.151af3c9c844ad3e9d640fe0baf8c0d1.svg";